import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { GetService } from './../../Services/get.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  User;
  userid;
  //for opening sidebar
  sideBartoggle= true;
  //for active buttons
  activeButton = [false,false];
  //for opening sidenav on hovering
  hover= false;
  currentYear:any;
  constructor(private getser:GetService , private rout:Router, private spinner: NgxSpinnerService) {}
//for opening and closing sidenav on mouseenter and mouseleave and closing submenu on mouseleave if opened and making button inactive
  hovering(){
    this.hover = !this.hover;
    let sidenav = document.getElementById("sidenav");

    if( !sidenav.classList.contains("clickopen")) {
      let sub_menu = document.getElementById("collapseThree");
      sub_menu.classList.remove("show");
      this.activeButton =[false,false]
    }

  }
//logout method

logOut(){
  this.spinner.show()
  setTimeout(() => {
    this.spinner.hide()
  }, 1000);
  this.getser.logout();
    this.rout.navigate(['/'])

}

  //for changing styles of active buttons
  activatedButton(i){
    this.activeButton[i] = !this.activeButton[i]
  }

  //for closing and opening sidebar
toggling(){
  this.sideBartoggle = !this.sideBartoggle;
  let div = document.getElementById("collapseThree");
  div.classList.remove("show");
  this.activeButton =[false,false]
}

  ngOnInit(): void {
    this.User = JSON.parse(localStorage.getItem('user'));
    this.userid = this.User.id;
    
this.currentYear = (new Date()).getFullYear();
}
}

